import { createContext } from 'react';

import { FormConfigType, TokenexFormConfigType } from '../@types';

// import { FormContextType } from '../@types';

export type TokenexContextType = {
  tokenexConfig: TokenexFormConfigType['options'];
  formConfig?: Partial<FormConfigType>;
};

const TokenexContext = createContext<TokenexContextType | null>(null);
const TokenexProvider = TokenexContext.Provider;

export { TokenexContext, TokenexProvider };
